<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid fill-height>
        <v-row align="center" align-content="center" justify="center">
          <v-col
            cols="12"
            class="mb-0 pb-0"
            align-self="center"
            justify-self="center"
          >
            <v-card
              elevation="0"
              max-width="350"
              class="mx-auto"
              color="rgba(0, 0, 0, 0)"
            >
              <v-card-text class="mb-0 pb-0">
                <div class="text-center mb-1 text-h4">
                  CANAL+ <span class="font-weight-medium">API</span>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-form
              @submit.prevent="login(form)"
              class="login"
              autocomplete="off"
            >
              <v-card
                max-width="340"
                elevation="1"
                class="pt-4 rounded-lg mx-auto"
              >
                <v-card-text class="text-center mb-0">
                  <div class="text-h5 black--text">
                    {{ $t("security.title") }}
                  </div>
                  <div>
                    <span class="body-2 grey--text text--darken-1">{{
                      $t("security.description")
                    }}</span>
                  </div>
                </v-card-text>
                <v-card-text class="mb-0 pb-1 px-7">
                  <v-text-field
                    prepend-icon="mdi-account-circle-outline"
                    name="username"
                    v-model="form.username"
                    :label="$t('security.fields.username.title')"
                    type="text"
                    autocomplete="off"
                    class="font-weight-bold"
                  ></v-text-field>
                  <v-text-field
                    prepend-icon="mdi-lock-outline"
                    name="password"
                    v-model="form.password"
                    :label="$t('security.fields.password.title')"
                    id="password"
                    type="password"
                    autocomplete="off"
                    class="font-weight-bold"
                  ></v-text-field>
                  <v-btn
                    block
                    color="primary"
                    :loading="loading"
                    type="submit"
                    class="mt-2 mb-5"
                    >{{ $t("security.btn.title") }}</v-btn
                  >
                </v-card-text>
              </v-card>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    loading: false,
    form: {
      username: null,
      password: null,
    },
  }),
  metaInfo() {
    return {
      title: this.$t("security.title"),
    };
  },
  methods: {
    async login(form) {
      let redirect = this.$auth.redirect();
      let message = "security.errors.E403";

      // hide old notification
      this.notify({ status: false });

      if (!this.form.username || !this.form.password) {
        this.notify({
          status: true,
          message: this.$t(message),
          right: false,
        });
        return;
      }

      this.loading = true;

      try {
        await this.$auth.login({
          data: form,
          ignoreVueAuth: true,
          redirect: { name: redirect ? redirect.from.name : "home" },
        });
      } catch (error) {
        const status = error.response ? error.response.status : 500;

        if (status !== 401) {
          message = "errors.500E";
        }

        this.notify({
          status: true,
          top: true,
          right: false,
          message: this.$t(message),
        });
      }
      this.loading = false
    },
    ...mapActions({
      notify: "notification/notify",
    }),
  },
};
</script>